 

export enum PageSpecificKeys {
    ReportPage = 'reportPage',
    DealsPage = 'dealsPage',
    DealPageBanners = 'dealPageBanners',
    DealsPageColumnOrder = 'dealsPageColumnOrder',
    DealsPageSorting = 'dealsPageSorting',
    DealDashboardPage = 'dealDashboardPage',
    ProFormaPage = 'proFormaPage',
    DocLibraryFilters = 'docLibraryFilters',
    DocLibraryRecentlyViewed = 'docLibraryRecentlyViewed',
    SignUpStage = 'signUpStage',
    SignUpData = 'signUpData',
    SignUpAuth0Data = 'signUpAuth0Data',
    IsDirectSignUpFlow = 'isDirectSignUpFlow',
    NewDealFormShowSuggestedOnly = 'newDealFormShowSuggestedOnly',
    SensitivityTables = 'sensitivityTables',
    ShowTargetReturns = 'showTargetReturns',
    ScenarioComparisonPage = 'scenarioComparisonPage',
    DealGroupColors = 'dealGroupColors',
    TimelineSectionsOpen = 'timelineSectionsOpen',
}

export enum GlobalKeys {
    AppStateBeforeRedirection = 'appStateBeforeRedirection',
    ProFormaSideNavCollapsed = 'isProFormaSideNavCollapsed',
    NavbarV2Collapsed = 'navbarV2_collapsed',
    ShowCents = 'showCents',
    ShowPartnerReturns = 'showPartnerReturns',
    CookieConsent = 'cookieConsent',
    ApartmentRetailReviewBadgeProformaIds = 'apartmentRetailReviewBadgeProFormaIds',
}

export enum ConsentValue {
    Granted = 'granted',
    NotGranted = 'not-granted',
}
